/*
 * BURST Oral Health Probiotic landing page interactions.
 * Sibling to pro2-landing.js. Delegated at document level (each section
 * emits its own `.prob-lp` wrapper, so there can be several roots) and
 * guarded against double-init (the asset tag may appear once per section).
 * Uses data-attributes only — no global functions, no inline onclick —
 * so nothing collides with the theme or with pro2-landing.js.
 */
(function () {
  'use strict';
  if (window.__probioticLPInit) return;
  window.__probioticLPInit = true;

  function init() {
    /* ---- Buy-box gallery thumbnail swap (document-delegated) ---- */
    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-prob-thumb]');
      if (thumb) {
        var scope = thumb.closest('.prob-lp') || document;
        var main = scope.querySelector('[data-prob-gallery-img]');
        if (main) main.src = thumb.getAttribute('data-prob-thumb');
        scope.querySelectorAll('[data-prob-thumb]').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        return;
      }

      // Sticky CTA button → trigger the offer form's real add-to-cart button
      var sticky = e.target.closest('[data-prob-sticky-atc]');
      if (sticky) {
        e.preventDefault();
        var addBtn = document.querySelector('#prob-offer .btn.add');
        if (addBtn) addBtn.click();
        return;
      }

      // On-page CTAs → center the buy card so the price + button are always in
      // view (native #prob-buy anchor + scroll-margin is the no-JS fallback).
      var buyLink = e.target.closest('a[href$="#prob-buy"]');
      if (buyLink) {
        var buyCard = document.getElementById('prob-buy');
        if (buyCard) {
          e.preventDefault();
          buyCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    });

    /* ---- Order-bump upsell: checkbox toggles the toothbrush line item ---- */
    /* The theme's add-to-cart serializer (global.js handleAddToCartClick)     */
    /* selects inputs by [name] and does NOT respect `disabled`. So we toggle   */
    /* the `name` attribute itself: no name when unchecked → excluded from the  */
    /* /cart/add payload; real name (from data-name) when checked → included.   */
    document.addEventListener('change', function (e) {
      var check = e.target.closest('[data-prob-upsell-check]');
      if (!check) return;
      var wrap = check.closest('[data-prob-upsell]');
      if (wrap) wrap.classList.toggle('checked', check.checked);
      var scope = check.closest('.prob-lp') || document;
      scope.querySelectorAll('[data-prob-upsell-input]').forEach(function (input) {
        if (check.checked) {
          input.setAttribute('name', input.getAttribute('data-name'));
        } else {
          input.removeAttribute('name');
        }
      });
    });

    /* ---- "Ships today" countdown to end of day (optional element) ---- */
    var countdown = document.querySelector('[data-prob-countdown]');
    if (countdown) {
      var tick = function () {
        var now = new Date();
        var end = new Date();
        end.setHours(23, 59, 59, 0);
        var diff = end - now;
        if (diff <= 0) { countdown.textContent = '0hr 0min'; return; }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        countdown.textContent = h + 'hr ' + m + 'min';
      };
      tick();
      setInterval(tick, 30000);
    }

    /* ---- 90-day timeline: reveal items on scroll + fill the line ---- */
    var vtrack = document.querySelector('.prob-lp .tl-vtrack');
    if (vtrack) {
      var fill = vtrack.querySelector('.tl-line-fill');
      var items = vtrack.querySelectorAll('.tl-item');
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { en.target.classList.add('in-view'); io.unobserve(en.target); }
          });
        }, { threshold: 0.35 });
        items.forEach(function (el) { io.observe(el); });
      } else {
        items.forEach(function (el) { el.classList.add('in-view'); });
      }
      var fillLine = function () {
        if (!fill) return;
        var r = vtrack.getBoundingClientRect();
        var prog = (window.innerHeight * 0.5 - r.top) / r.height;
        prog = Math.max(0, Math.min(1, prog));
        fill.style.height = (prog * 100) + '%';
      };
      window.addEventListener('scroll', fillLine, { passive: true });
      window.addEventListener('resize', fillLine);
      fillLine();
    }

    /* ---- Sticky CTA bar (hidden while the offer section is in view) ---- */
    var bar = document.querySelector('.prob-lp-sticky-cta');
    var offer = document.getElementById('prob-offer');
    if (bar) {
      var onScroll = function () {
        var show = window.scrollY > 700;
        if (offer) {
          var r = offer.getBoundingClientRect();
          if (r.top < window.innerHeight && r.bottom > 0) show = false;
        }
        bar.classList.toggle('visible', show);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
